import { Injectable } from '@angular/core';
import { appSettings } from '../settings';
import * as moment from "moment";
import { DashboardService } from './dashboard.service';
import { UserPreference } from '../models/UserPreference';
import { CommonService } from './common.service';

@Injectable()
export class WidgethelperService {

  constructor(private _commonService: CommonService,
    private _dashboardService: DashboardService) { }

  GetSummaryTypeNo(str): number {
    switch (str) {
      case appSettings.Last1month:
        return 2;
      case appSettings.Last2months:
        return 3;
      case appSettings.Last3months:
        return 4;
      case appSettings.Last6months:
        return 7;
      case appSettings.Last13months:
        return 14;
      case appSettings.LastWeek:
        return 2;
      case appSettings.Last2Weeks:
        return 3;
      case appSettings.CustomRange:
        return 0;
    }
  }

  GetSummaryType(str): string {
    switch (str) {
      case appSettings.Last1month:
        return 'M';
      case appSettings.Last2months:
        return 'M';
      case appSettings.Last3months:
        return 'M';
      case appSettings.Last6months:
        return 'M';
      case appSettings.Last13months:
        return 'M';
      case appSettings.LastWeek:
        return 'W';
      case appSettings.Last2Weeks:
        return 'W';
      case appSettings.CustomRange:
        return 'D';
    }
  }

  ProgresstrackingTooltip(params): string {
    //console.log(params);
    return params.seriesName + ' : ' + params.data.order;
  }

  PulltimemonitorTooltip(params): string {
    //console.log(params);
    return (
      "Pending : " +
      params[0].data.Pending +
      " </br> " +
      " Shipped : " +
      params[1].value
    );
  }

  PulltimemonitorAxisLabel(value): string {
    return value * 0.1 + "%";
  }

  WavepulltimeTooltip(params): string {
    //console.log('WavepulltimeTooltip', params);
    return (
      params[0].axisValue +
      " </br> " +
      "Pending : " +
      params[0].data.Pending +
      " </br> " +
      " Shipped : " +
      params[1].value
    );
  }

  WaveTrendTooltip(params): string {
    //console.log('WaveTrendTooltip', params);
    return params[0].data[2] + ' (' + params[0].data[0] + ') : ' + params[0].data[1] + ' mins';
  }

  WavePerformanceTooltip(params): string {
    //console.log('WavePerformanceTooltip', params);
    return params[0].data[6] +
      ' (' + params[0].data[0] + ') : <br>' +
      'Total Cartons : ' + params[0].data[1] + '<br>' +
      'Total Orders Allocated : ' + params[0].data[2] + '<br>' +
      'Total Orders Dropped : ' + params[0].data[3] + '<br>' +
      'Total Orders Partially Allocated : ' + params[0].data[4] + '<br>' +
      'Total Orders Shorted : ' + params[0].data[5] + '<br>' +
      'Wave Selected Time : ' + params[0].data[7] + ' mins <br>' +
      'Wave Allocated Time : ' + params[0].data[8] + ' mins <br>' +
      'Wave Cube Time : ' + params[0].data[9] + ' mins <br>' +
      'WaveTask Generated Time : ' + params[0].data[10] + ' mins';
  }

  WavepulltimeAxisLabel(value): string {
    return value * 0.1 + "%";
  }

  WavepulltimeSeriesLabel(params): string {
    //console.log(params);
    return params.value;
  }

  WavepulltimeItemStyle(params): string {
    //console.log(params.data);
    return params.data.name;
  }

  NameWrapper(value, index): string {
    let width = 15;
    let re = new RegExp("([\\w\\s]{" + (width - 2) + ",}?\\w)\\s?\\b", "g")
    return value.replace(re,"$1\n");
  }


  reload(widget: any ) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    
    
    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        let widgetSettingParam = {
          WidgetType:widget.type,
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        widget.hub
          .invoke("RemoveWidget", widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
            }
          });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = widget.type;
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  CreateHub(widget)
  {
    console.log(widget.Title);
    widget.dataLoaded = false;
    widget.errorMessage = "Retrieving records. Please wait...";
    let currentDateTime = moment()
      .toDate()
      .getTime();    
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = widget.type;
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: widget.type,
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub
          .invoke("RemoveWidget", widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
            }
            console.log("deleteWidget " + widget.type + " RemoveWidget");
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  unique(value, index, self): any {
    return self.indexOf(value) === index;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgethelper.service.ts